module.exports = __webpack_public_path__ + "img/summary-dispute-requested.54f47017.svg";